// removed by extract-text-webpack-plugin
module.exports = {"wysiwyg":"Wysiwyg-module-wysiwyg-2JB3V","table-wrapper":"Wysiwyg-module-table-wrapper-pgsVq","tableWrapper":"Wysiwyg-module-table-wrapper-pgsVq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Wysiwyg/Wysiwyg.module.scss
// module id = 1084
// module chunks = 0